import React from 'react';
import CustomTextField from '../../components/CustomTextField';

export const renderTextField = (
  { input, meta, label, ...custom }
) => {
  const {active, touched, error} = meta
  // console.log('input ',input);
  //console.log('meta ', meta);
  // console.log('custom ', custom);
  return <CustomTextField
  input={input}
  {...custom}
  errorText={!active && touched && error}
  />
};



// WEBPACK FOOTER //
// ./src/ReduxFormFields/utils/fields.js